import { SERVER_API } from "../../Constant";

export const CallAiAgent_api = async (
  prompt: string,
  chatHistory: any[] | null = null,
  currentWorkspace: any | null = null
) => {
  try {
    const response = await fetch(
      `${SERVER_API}/Reports/ai_reports_agent.php`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ prompt, chatHistory, currentWorkspace }),
      },
    );
    return await response.json();
  } catch (error) {
    console.error("Error in CallAiAgent_api:", error);
    return { success: false, msg: "Network error connecting to AI agent" };
  }
};
